import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { LandscapeState } from 'vms-state';
import * as VmsState from '../../backend/index-vms-state';
import * as Routing from '../../backend/reducers/routing';
import { TextFieldEditor, VenueList } from '../../components';
import s from './Venues.module.scss';

class Venues extends Component {
    static propTypes = {
        loading: PropTypes.bool.isRequired,
        dispatch: PropTypes.func.isRequired,
        hasLoaded: PropTypes.bool,
        venueList: PropTypes.array,
        venueSearchText: PropTypes.string,
    };

    static defaultProps = {
        hasLoaded: false,
        venueList: [],
        venueSearchText: '',
    };

    onVenueSelect = venueId => {
        const { dispatch } = this.props;
        dispatch(Routing.Actions.goToVenue(venueId));
    };

    onSearchTextChanged = searchText => {
        const { dispatch } = this.props;
        dispatch(VmsState.ViewReducer.Actions.changeVenueSearchText(searchText));
    };

    render() {
        const { loading, hasLoaded, venueList, venueSearchText } = this.props;

        const showLoading = venueList.length === 0 && loading;

        return (
            <div className={s.venues}>
                <div className={s.venuesInner}>
                    <div className={s.infoWrapper}>
                        <div className={s.titleWrapper}>
                            <div className={s.title}>Venues</div>
                            <div className={s.venueCount}>({venueList.length})</div>
                        </div>
                        <div className={s.subtitle}>Below you can view all venues associated with your account</div>
                        <div className={s.searchAddWrapper}>
                            <TextFieldEditor className={s.searchBox} iconLeft="icon-search" onChange={this.onSearchTextChanged} placeHolder="Search for a Venue..." value={venueSearchText} />
                        </div>
                    </div>
                    <div className={s.listWrapper}>
                        <VenueList venuesToRender={venueList} loading={showLoading} onVenueSelect={this.onVenueSelect} className={s.list} hasLoaded={hasLoaded} />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const venueSearchText = VmsState.ViewReducer.Selectors.getVenueSearchText(state);
    return {
        loading: LandscapeState.selectors.isLoadingVenueList(state),
        hasLoaded: LandscapeState.selectors.hasVenueListLoaded(state),
        venueList: LandscapeState.selectors.searchVenueSummaries(venueSearchText, state?.featureFlags?.translatedVenues),
        venueSearchText,
    };
};

export default connect(mapStateToProps)(Venues);
